import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './bootstrap-icons-classes.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { CartProvider } from './state/cart/CartProvider';
import { AuthProvider } from './state/auth/AuthProvider';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <App />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
    const swPath = `${base}/sw.js`.replace(/^\/{2,}/, '/');

    let skipReloadOnFirstController = true;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (skipReloadOnFirstController) {
        skipReloadOnFirstController = false;
        return;
      }
      window.location.reload();
    });

    void navigator.serviceWorker
      .register(swPath, { updateViaCache: 'none' })
      .then((registration) => {
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            void registration.update();
          }
        });
      })
      .catch(() => undefined);
  });
}
